function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "clock--red");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u2693\\uFE0F-The-Shipyard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Artboard",
  transform: "translate(-65.000000, -38.000000)",
  fill: "#E31F26"
}, React.createElement("path", {
  d: "M73,38 C77.418278,38 81,41.581722 81,46 C81,50.418278 77.418278,54 73,54 C68.581722,54 65,50.418278 65,46 C65,41.581722 68.581722,38 73,38 Z M73,39.8823529 C69.6213168,39.8823529 66.8823529,42.6213168 66.8823529,46 C66.8823529,49.3786832 69.6213168,52.1176471 73,52.1176471 C76.3786832,52.1176471 79.1176471,49.3786832 79.1176471,46 C79.1176471,42.6213168 76.3786832,39.8823529 73,39.8823529 Z M73,40.9411765 C73.479813,40.9411765 73.8757666,41.3002213 73.9338434,41.7642938 L73.9411765,41.8823529 L73.9411765,46.0070588 L75.7738481,46.9228921 C76.2000256,47.1359808 76.3938878,47.6287803 76.2441848,48.0675413 L76.194755,48.1856128 C75.9622945,48.6505337 75.3969552,48.8389802 74.9320343,48.6065197 L72.5790931,47.4300491 L72.5766227,47.4288095 C72.4683964,47.374497 72.3718368,47.299339 72.2923754,47.2088027 C72.2762469,47.1907484 72.2611746,47.1721381 72.2468685,47.1530305 C72.2383203,47.1413942 72.2300192,47.1298014 72.221979,47.1180165 C72.210552,47.1013609 72.1994875,47.0838815 72.1890222,47.0660822 C72.1771506,47.0460263 72.1662714,47.0259499 72.1561171,47.0054505 C72.1530532,46.9988961 72.1496917,46.991877 72.1464181,46.9848193 C72.1187323,46.9257034 72.0973032,46.8636365 72.0825215,46.7990359 C72.0772552,46.7752877 72.0728277,46.7520462 72.0692764,46.7286422 C72.0681643,46.7215738 72.0671145,46.7139484 72.0661566,46.7062945 L72.0638323,46.6863358 C72.0611165,46.6606525 72.0594521,46.6348126 72.0588235,46.608882 L72.0588235,46.5882353 L72.0588235,41.8823529 C72.0588235,41.3625555 72.4802026,40.9411765 73,40.9411765 Z",
  id: "clock--red"
})));

var SvgClockRed = function SvgClockRed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgClockRed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clock--red.e90c4c3e.svg";
export { ForwardRef as ReactComponent };